import { createFileRoute } from '@tanstack/react-router';

import { SeancePageWidget } from '@features/game/pages/SeancePage';

export const Route = createFileRoute('/club/$clubId_/tournament/$tournamentId_/seance')({
  component: Page,
});

function Page() {
  const { clubId, tournamentId } = Route.useParams();
  return <SeancePageWidget key={tournamentId} clubId={clubId} tournamentId={tournamentId} />;
}
